module.exports = __webpack_public_path__ + "img/v4_underlyingPriceManageList.d027a581.png";